/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputEditAdminUser
 */
export interface InputEditAdminUser {
    /**
     * 
     * @type {string}
     * @memberof InputEditAdminUser
     */
    comment?: string;
    /**
     * 
     * @type {number}
     * @memberof InputEditAdminUser
     */
    division?: number;
    /**
     * 
     * @type {string}
     * @memberof InputEditAdminUser
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof InputEditAdminUser
     */
    osg?: number;
    /**
     * 
     * @type {number}
     * @memberof InputEditAdminUser
     */
    otg?: number;
    /**
     * 
     * @type {string}
     * @memberof InputEditAdminUser
     */
    role: string;
    /**
     * 
     * @type {number}
     * @memberof InputEditAdminUser
     */
    zone?: number;
}

/**
 * Check if a given object implements the InputEditAdminUser interface.
 */
export function instanceOfInputEditAdminUser(value: object): boolean {
    if (!('name' in value)) return false;
    if (!('role' in value)) return false;
    return true;
}

export function InputEditAdminUserFromJSON(json: any): InputEditAdminUser {
    return InputEditAdminUserFromJSONTyped(json, false);
}

export function InputEditAdminUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputEditAdminUser {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
        'division': json['division'] == null ? undefined : json['division'],
        'name': json['name'],
        'osg': json['osg'] == null ? undefined : json['osg'],
        'otg': json['otg'] == null ? undefined : json['otg'],
        'role': json['role'],
        'zone': json['zone'] == null ? undefined : json['zone'],
    };
}

export function InputEditAdminUserToJSON(value?: InputEditAdminUser | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comment': value['comment'],
        'division': value['division'],
        'name': value['name'],
        'osg': value['osg'],
        'otg': value['otg'],
        'role': value['role'],
        'zone': value['zone'],
    };
}

